<template>
  <div style="width:100%;padding-top: 60px">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%; background-color:#fff;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">办理</van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea" placeholder="请输入审批说明" />
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>

    <van-collapse v-model="activeNames">
      <div style="padding-left: 16px">
        <van-field v-model="inputForm.inboundTypeLabel" label="原料果入库类型" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.inboundStatusLabel" label="原料果入库状态" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-if="inputForm.inboundType === '0'" v-model="inputForm.departOrderNo" label="原料果发车单编号" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-if="inputForm.inboundType === '3'" v-model="inputForm.rawOutboundNo" label="转库出库单编号" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-if="inputForm.inboundType === '0'" v-model="inputForm.cgOfficeName" label="采购中心小组" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-if="inputForm.inboundType === '0'" v-model="inputForm.companyName" label="贸易所属公司" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-if="inputForm.inboundType === '0'" v-model="inputForm.czOperatorName" label="采摘负责人" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.packAddressName" label="冷库" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.secondaryColdStorageName" label="二级冷库" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.officeName" label="包装小组" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.operatorName" label="包装组长" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.varietyName" label="品种" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-if="inputForm.inboundType !== '2'" v-model="inputForm.farmName" label="种植园" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-if="inputForm.inboundType === '2'" v-model="inputForm.coldStorageName" label="来源" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-if="inputForm.inboundType === '0' || inputForm.inboundType === '3'" v-model="inputForm.plateNo" label="原料果转运车牌号" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.inboundDate" label="入库日期" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.createByName" label="制单人" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.createDate" label="制单日期" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      </div>
      <van-collapse-item v-if="inputForm.inboundType === '3'" title="原料果出库信息" name="outbound">
        <van-field v-model="inputForm.rawOutboundNo" label="转库出库单编号" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.outboundDate" label="出库日期" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.departTruckWeight" :formatter="formatter" label="装车过磅总重（斤）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.departTareWeight" :formatter="formatter" label="空车过磅重量（斤）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.departTotalWeightIncludePack" :formatter="formatter" label="含筐总重（斤）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.departTruckNum" label="出库总件数（筐）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.departTotalWeightExcludePackIncludeLoss" :formatter="formatter" label="不含筐总重（斤）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <div style=" margin-bottom: 10px; margin-top: 10px; padding-left: 16px" v-if="inputForm.detailListOutbound && inputForm.detailListOutbound.length > 0">
          <p style="display: block; color: #4caedc" @click="viewOutboundDetail()">查看原料果出库明细</p>
        </div>
      </van-collapse-item>
      <van-collapse-item title="原料果发车信息" name="1" v-if="inputForm.inboundType === '0'">
        <van-field v-model="inputForm.departTareWeight" :formatter="formatter" label="空车过磅重量（斤）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.departTruckWeight"  :formatter="formatter"label="装车过磅总重（斤）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.departTruckNum" label="装车总件数（筐）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.departTotalWeightIncludePack" :formatter="formatter" label="含筐总重（斤）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.departTotalWeightExcludePackIncludeLoss" :formatter="formatter" label="不含筐含果损总重（斤）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.contractLossWeight" label="合同约定果损（%）" :formatter="formatter" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.eachLoseWeight" label="本车果损（斤）" :formatter="formatter" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.settleWeight" label="扣除果损后结算重量（斤）" :formatter="formatter" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <div style=" margin-bottom: 10px; margin-top: 10px; padding-left: 16px">
          <p style="display: block; color: #4caedc" @click="viewDetail()">查看原料果发车明细</p>
        </div>
      </van-collapse-item>
      <van-collapse-item title="原料果入库信息" name="2">
        <van-field v-if="inputForm.inboundType !== '1'" v-model="inputForm.weighFlagLabel" label="称重方式" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-if="inputForm.inboundType === '0'" v-model="inputForm.truckTypeLabel" label="车型" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-show="inputForm.weighFlag === '0'" v-model="inputForm.truckWeight" :formatter="formatter" label="装车过磅总重（斤）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-show="inputForm.weighFlag === '0'" v-model="inputForm.tareWeight" :formatter="formatter" label="空车过磅重量（斤）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.totalWeightIncludePack" :formatter="formatter" label="含筐总重（斤）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.truckNum" label="入库总件数（筐）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.totalPackWeight" :formatter="formatter" label="包装材料总重（斤）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.totalWeightExcludePack" :formatter="formatter" label="不含筐总重（斤）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <div style=" margin-bottom: 10px; margin-top: 10px; padding-left: 16px">
          <p style="display: block; color: #4caedc" @click="viewDetail2()">查看原料果入库明细</p>
        </div>
      </van-collapse-item>
      <van-collapse-item v-show="inputForm.inboundType === '0' || inputForm.inboundType === '3'" :title="inputForm.inboundType === '3' ? '原料果入库与出库数据比对情况' : '原料果入库与发车数据比对情况'" name="3">
        <van-field v-if="inputForm.inboundType === '0'" v-model="inputForm.diffTareWeight" :formatter="formatter" label="空车过磅重量差额（斤）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-if="inputForm.inboundType === '0'" v-model="inputForm.diffTruckWeight" :formatter="formatter" label="装车过磅总重差额（斤）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.diffTotalWeightIncludePack" :formatter="formatter" label="含筐总重差额（斤）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.diffTotalPackWeight" :formatter="formatter" label="包装材料总重差额（斤）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      </van-collapse-item>
      <van-collapse-item v-show="inputForm.inboundType === '0' || inputForm.inboundType === '3'" :title="inputForm.inboundType === '3' ? '入库净重与出库净重损益情况' : '入库净重与发车结算净重损益情况'" name="5">
        <van-field v-model="inputForm.diffTotalWeightExcludePack" :formatter="formatter" label="损益重量（斤）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.diffTotalWeightExcludePackRate" :formatter="formatter" label="损益率（%）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      </van-collapse-item>
      <van-collapse-item title="入库过磅费" name="4">
        <van-field v-model="inputForm.weighFee" :formatter="formatter" label="过磅费（元）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.weighFeeAttachList.length > 0">
          <p style="color: #AAA">过磅小票</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.weighFeeAttachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
        <van-field v-model="inputForm.remark" label="备注" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      </van-collapse-item>

    </van-collapse>
    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import processRecord from "../../../../../components/processRecord/processRecord.vue";
import TaskService from "../../../../../api/flowable/TaskService";
import ProcessService from "../../../../../api/flowable/ProcessService";
import QueryInfoService from "@/api/system/queryInfoService";
export default {
  name: "ItsStockRawInBound",
  data(){
    return {
      activeNames: ['1','2','3','4','5','outbound'],
      isshow: false,
      radio: '',
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type:'',
      inputForm:{
        attachList: [],
        detailListOutbound: [],
        isDoTask: false,
        isLastTask: false,
      },
      flowTable: 'its_stock_raw_inbound'
    }
  },
  components: {
    processRecord
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.$flow.queryById(id, '/its/stock/itsStockRawInbound/queryById').then(({ data }) => {
        this.inputForm = data
        if(!data.weighFeeAttachList) {
          this.inputForm.weighFeeAttachList = []
        }
        this.getDict([
          ['its_raw_inbound_type', 'inboundType'],
          ['its_raw_inbound_status', 'inboundStatus'],
          ['its_order_weigh_flag', 'weighFlag'],
        ])
        this.updateDictNames(this.inputForm.detailList1,{its_base_variety_level:'varietyLevel'})
        this.updateDictNames(this.inputForm.detailList2,{its_base_variety_level:'varietyLevel'})
        if(this.inputForm.inboundType === '3') {
          this.updateDictNames(this.inputForm.detailListOutbound,{its_base_variety_level:'varietyLevel'})
        }
      }).catch(e => {
        console.log(e)
      })
    },
    getDict(dicts){
      new QueryInfoService().getDictMap().then(({data}) => {
        dicts.map(([dictType, formField]) => {
          this.$set(this.inputForm, `${formField}Label`, data[dictType].find(item=>item.value==this.inputForm[formField]).label);
        });
      }).catch(e => {
        console.log(e)
      })
    },
    async updateDictNames(dataList, dictTypeList) {
      const {data} = await new QueryInfoService().getDictMap();
      const promises = dataList.map(async (item) => {
        for (const [dictType, formField] of Object.entries(dictTypeList)) {
          if (data[dictType] && Array.isArray(data[dictType])) {
            const dictItem = data[dictType].find(d => d.value === item[formField]);
            if (dictItem) {
              this.$set(item, `${formField}Label`, dictItem.label);
            }
          }
        }
      });
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        // vars = { ...vars, ..._this.inputForm }
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          let form = {
            id: _this.inputForm.id,
            flowType: _this.inputForm.isLastTask ? 4 : 2,
            formKey: _this.formKey,
            flowTable: _this.flowTable,
          }
          // _this.inputForm.flowType = _this.inputForm.isLastTask?4:2;
          _this.$flow.startFlow(form, '/its/comm/flow/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          // _this.inputForm.flowType = 3;
          let form = {
            id: _this.inputForm.id,
            flowType: 3,
            formKey: _this.formKey,
            flowTable: _this.flowTable,
          }
          _this.$flow.startFlow(form, '/its/comm/flow/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    formatter(value){
      return Number(value).toFixed(2)
    },
    viewDetail(){
      this.$router.push({
        path: '/ItsStockRawInBoundDepartDetail',
        query: {
          data: JSON.stringify(this.inputForm.detailList1),
          inboundType: this.inputForm.inboundType
        }
      })
    },
    viewDetail2(){
      this.$router.push({
        path: '/ItsStockRawInBoundWarehousingDetail',
        query: {
          data: JSON.stringify(this.inputForm.detailList2),
          inboundType: this.inputForm.inboundType,
          weighFlag: this.inputForm.weighFlag
        }
      })
    },
    viewOutboundDetail(){
      this.$router.push({
        path: '/ItsStockRawInBoundWarehousingDetail',
        query: {
          data: JSON.stringify(this.inputForm.detailListOutbound),
          inboundType: this.inputForm.inboundType,
          weighFlag: this.inputForm.weighFlag,
          detailType: 'outbound'
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
